import { put, takeLatest } from "redux-saga/effects";
import { requestForGetProposalDeatil, requestForAcceptProposalDeatil,requestForUpdateTimeView } from "./../../../services/public-service/index";
import {
 fetchProposalDetailFailure,
 fetchProposalDetailRequest,
 fetchProposalDetailSuccess ,
 acceptProposalDetailFailure,
 acceptProposalDetailRequest,
 acceptProposalDetailSuccess,
 updateViewTimeRequest,
 updateViewTimeFailure,
 updateViewTimeSuccess
} from "../../reducers/public-proposal/index";

export function* watchBusinessProposalSaga() {
  yield takeLatest(fetchProposalDetailRequest, fetchProposalDetail)
  yield takeLatest(acceptProposalDetailRequest, acceptProposalDetail)
  yield takeLatest(updateViewTimeRequest, updateViewTime)
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchProposalDetail({ payload }) {
  try {
    const response = yield requestForGetProposalDeatil(payload);
    yield put(fetchProposalDetailSuccess(response));
  } catch (error) {
    yield put(
        fetchProposalDetailFailure("Failed to get proposal detail")
    );
  }
}

/**
 *
 * @param {PARAMS} param0
 */
 function* acceptProposalDetail({ payload }) {
  try {
    const response = yield requestForAcceptProposalDeatil(payload);
    yield put(acceptProposalDetailSuccess(response));
  } catch (error) {
    yield put(
      acceptProposalDetailFailure("Failed to accept proposal detail")
    );
  }
}

/**
 *
 * @param {PARAMS} param0
 */
 function* updateViewTime({ payload }) {
  try {
    const response = yield requestForUpdateTimeView(payload);
    yield put(updateViewTimeSuccess(response));
  } catch (error) {
    yield put(
      updateViewTimeFailure("Failed to accept proposal detail")
    );
  }
}
